<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        {{ t('stateGroupDetail.description') }}
      </p>
    </div>
  </div>
  <drdp-report-search [hasSubfilters]="true" [multiSelectAgencies]="true" [allAgenciesCheckbox]="true" [is2025]="is2025"
    [displaySite]="false" [displayClassroom]="false" [displayDownload]="false" [requiredFields]="requiredFields" [omitTestAgencies]="true"
    [ratingPeriodLabel]="t('stateGroupDetail.ratingPeriodLabel')" [showReportBtnText]="t('actions.sendRequest')" (showReportClicked)="showReport($event)" [displayCounty]="true" [showSubfilterCheckAll]="false">
  </drdp-report-search>
</div>
</ng-container>
